"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[7945],{

/***/ 7945:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Footer)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function Footer({ wrapper }) {
  const settings = {
    accordionButtons: '[data-footer-accordion-button]',
    accordionContent: '[data-footer-accordion-content]',
    spinningLogoToggle: '[data-spinning-logo-toggle]',
    spinningLogoImage: '[data-spinning-logo] img',
  }

  ;(function init() {
    initializeEventListeners()
  })()

  function initializeEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.accordionButtons).on('click', toggleAccordion)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.spinningLogoToggle).on('click', toggleSpinningLogo)
  }

  function toggleAccordion(e) {
    e.preventDefault()

    const $button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    const $content = $button.siblings(settings.accordionContent)
    const $svg = $button.find('[data-footer-plus-vertical-line]')
    const maxHeight = $content[0].scrollHeight

    if ($content.hasClass('active')) {
      $content.css('max-height', '').removeClass('active').attr('aria-hidden', true)
      $svg.show()
      $button.removeClass('active').attr('aria-expanded', false)
    } else {
      $content.css('max-height', maxHeight).addClass('active').attr('aria-hidden', false)
      $svg.hide()
      $button.addClass('active').attr('aria-expanded', true)
    }
  }

  /* Toggle spinning logo */
  function toggleSpinningLogo(e) {
    e.preventDefault()
    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-spinning-logo]').is('.on')) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.spinningLogoImage).removeClass('footer-snuggle-snooze-repeat')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-spinning-logo]').removeClass('on')
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.spinningLogoImage).addClass('footer-snuggle-snooze-repeat')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-spinning-logo]').addClass('on')
    }
  }
}


/***/ })

}]);